import { useEffect } from 'react'

import Image from 'next/image'

import { useModuleContext } from '@/contexts/ModuleContext'
import { Button } from '@getethos/ethos-design-system-v2'

import { TRUST_IMAGE_GROUPS_FFFFFF } from '../SingleCTADirect/constants'
import styles from './SingleCTABrandRefresh.module.scss'

const CONSTANTS = {
  HEADLINE: 'Instant, <br /> affordable life <br /> insurance',
  SUBHEADLINE: 'Get covered in 10 min without a med exam',
  CTA: 'Check my price',
  WREATHS: [
    {
      src: 'https://res.cloudinary.com/getethos/image/upload/v1753035888/ForbesAdvisor_vhmtrx.svg',
      imageAlt: 'Forbes Advisor',
      imageWidth: 167,
      imageHeight: 101,
    },
    {
      src: 'https://res.cloudinary.com/getethos/image/upload/v1753035888/Best_Business_Insider_majq7v.svg',
      imageAlt: 'Best Business Insider',
      imageWidth: 167,
      imageHeight: 101,
    },
  ],
}

interface SingleCTABrandRefreshProps {
  ctaClick: (props: { flow?: string; label?: string }) => void
}

export const SingleCTABrandRefresh = ({
  ctaClick,
}: SingleCTABrandRefreshProps) => {
  const {
    navBarControls: { hideNavBar },
  } = useModuleContext()

  useEffect(() => {
    hideNavBar(false)
  }, [hideNavBar])

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1
            className={styles.headline}
            dangerouslySetInnerHTML={{ __html: CONSTANTS.HEADLINE }}
          />
          <p className={styles.subheadline}>{CONSTANTS.SUBHEADLINE}</p>
          <Button
            buttonTitle={CONSTANTS.CTA}
            variant="primary"
            size="md"
            className={styles.cta}
            onClick={() => ctaClick({ label: CONSTANTS.CTA })}
          />
          <div className={styles.trustImages}>
            {CONSTANTS.WREATHS.map((image) => (
              <Image
                src={image.src}
                alt={image.imageAlt}
                width={image.imageWidth}
                height={image.imageHeight}
                objectFit="contain"
                key={image.imageAlt}
                priority
              />
            ))}
          </div>
        </div>
        <div className={styles.imageContainer}>
          <Image
            src="https://res.cloudinary.com/getethos/image/upload/v1736768846/a4a80674302dbb345546ec7ae210e8eb_trg43e_kc13kv.webp"
            alt="Ethos Logo"
            fill
            objectFit="contain"
            priority
            unoptimized
          />
        </div>
      </div>
    </section>
  )
}
